import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../../common/apiConfig';
import {
  MANAGE_OUTS_FETCH_AUDIT_LOG_BEGIN,
  MANAGE_OUTS_FETCH_AUDIT_LOG_SUCCESS,
  MANAGE_OUTS_FETCH_AUDIT_LOG_FAILURE,
  MANAGE_OUTS_FETCH_AUDIT_LOG_DISMISS_ERROR,
  MANAGE_OUTS_ERROR_CONTACT_ADMIN,
} from './constants';

export function fetchAuditTrailLogs(formData = {}) {
  return (dispatch, getState) => {
    dispatch({ type: MANAGE_OUTS_FETCH_AUDIT_LOG_BEGIN });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;

      const pageIndex = parseInt(formData.pageIndex, 10) || 1;
      const pageSize = parseInt(formData.pageSize, 10) || 5;
      const payload = Object.keys(formData || {}).reduce((acc, k) => {
        const v = formData[k];
        if (v === undefined || v === '') return acc;
        acc[k] = v;
        return acc;
      }, {});
      payload.pageIndex = pageIndex;
      payload.pageSize = pageSize;
       // Logs API expects exactly one identifier - never send both together
      if (payload.customerShipTo) {
        delete payload.conceptId;
      } else if (payload.conceptId) {
        delete payload.customerShipTo;
      }


      const doRequest = axios.post(
        `${API_REQUEST_URL}/manageOutsHistoryTrack`,
        payload,
        { headers: { Authorization: token, 'Content-Type': 'application/json' } },
      );


      doRequest.then(
        res => {
          const rows = res.data && (res.data.data || res.data.rows) ? (res.data.data || res.data.rows) : [];
          const total = res.data && (res.data.total || res.data.totalCount) ? (res.data.total || res.data.totalCount) : (Array.isArray(rows) ? rows.length : 0);
          const payload = { rows, total, pageIndex, pageSize };

          dispatch({
            type: MANAGE_OUTS_FETCH_AUDIT_LOG_SUCCESS,
            data: payload,
          });

          resolve(payload);
        },
        err => {
          // const errorMsg = err && err.response ? err.response.data.message : MANAGE_OUTS_ERROR_CONTACT_ADMIN;
          const errorMsg = `No Audit History Found`;
          dispatch({
            type: MANAGE_OUTS_FETCH_AUDIT_LOG_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchAuditTrailLogsError() {
  return { type: MANAGE_OUTS_FETCH_AUDIT_LOG_DISMISS_ERROR };
}

export function useFetchAuditTrailLogs() {
  const dispatch = useDispatch();
  const { auditLogData, auditLogTotal, fetchAuditLogPending, fetchAuditLogError } = useSelector(
    state => ({
      auditLogData: state.manageOutsAuditTrail.auditLogData,
      auditLogTotal: state.manageOutsAuditTrail.auditLogTotal,
      fetchAuditLogPending: state.manageOutsAuditTrail.fetchAuditLogPending,
      fetchAuditLogError: state.manageOutsAuditTrail.fetchAuditLogError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => dispatch(fetchAuditTrailLogs(...args)), [dispatch]);
  const boundDismiss = useCallback(() => dispatch(dismissFetchAuditTrailLogsError()), [dispatch]);

  return {
    auditLogData,
    auditLogTotal,
    fetchAuditTrailLogs: boundAction,
    fetchAuditLogPending,
    fetchAuditLogError,
    dismissFetchAuditTrailLogsError: boundDismiss,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_OUTS_FETCH_AUDIT_LOG_BEGIN:
      return {
        ...state,
        fetchAuditLogPending: true,
        fetchAuditLogError: null,
      };

    case MANAGE_OUTS_FETCH_AUDIT_LOG_SUCCESS:
      return {
        ...state,
        auditLogData: action.data.rows || [],
        auditLogTotal: action.data.total || 0,
        fetchAuditLogPending: false,
        fetchAuditLogError: null,
      };

    case MANAGE_OUTS_FETCH_AUDIT_LOG_FAILURE:
      return {
        ...state,
        fetchAuditLogPending: false,
        fetchAuditLogError: action.data.error,
      };

    case MANAGE_OUTS_FETCH_AUDIT_LOG_DISMISS_ERROR:
      return {
        ...state,
        fetchAuditLogError: null,
      };

    default:
      return state;
  }
}